import React from "react";
import { useLocation } from "react-router-dom";

// Business WhatsApp number (E.164, digits-only). Change here to swap globally.
const WA_NUMBER = "919960868323";
const WA_DEFAULT_MSG = "Hi INPropPortal, I'd like to know more about your services.";

// Route prefixes where the FAB should NOT show (dashboards, auth, billing, onboarding).
const HIDDEN_PREFIXES = ["/dashboard", "/admin", "/login", "/register", "/subscribe", "/onboarding", "/billing"];

function WhatsAppGlyph({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <path
        fill="currentColor"
        d="M19.1 17.3c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1s-.8.9-.9 1.1c-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.5-1.8-1.6-2.1-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5H9.7c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.2.2 2.1 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.5-.3zM16 5.4C10 5.4 5.1 10.3 5.1 16.4c0 1.9.5 3.7 1.4 5.3L5 27.2l5.6-1.5c1.5.8 3.3 1.3 5.1 1.3h.4c6 0 10.9-4.9 10.9-10.9C27 10.2 22.1 5.4 16 5.4zm0 19.9h-.3c-1.6 0-3.2-.4-4.6-1.2l-.3-.2-3.4.9.9-3.3-.2-.3c-1-1.5-1.4-3.2-1.4-4.9C6.7 11 10.9 6.8 16 6.8s9.3 4.2 9.3 9.6c0 5.3-4.2 9.5-9.3 8.9z"
      />
    </svg>
  );
}

export default function WhatsAppFAB({ message = WA_DEFAULT_MSG }) {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) return null;

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with INPropPortal on WhatsApp"
      title="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-[60] group inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.7)] hover:shadow-[0_16px_36px_-10px_rgba(37,211,102,0.85)] pl-3 pr-4 py-3 transition-all hover:scale-[1.03] active:scale-95"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/15 group-hover:bg-white/25 transition-colors">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping opacity-40" aria-hidden="true" />
        <WhatsAppGlyph className="w-6 h-6" />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-tight" data-testid="whatsapp-fab-label">
        Chat on WhatsApp
      </span>
    </a>
  );
}
